






































































































































































































































































































































import Vue from 'vue';
// import { GridLayout, GridItem } from 'vue-grid-layout';
import Gadgets from '../components/gadgets';
import {VUECHARTGRAPH, IGraph, CFrame} from '@/components/gadgets/BasicGadget.vue';
import GraphTooltip from '@/parts/graph/GraphTooltip.vue';
import GadgetEditer3 from '@/parts/dashboard/GadgetEditer3.vue';
import AddNewGadgetV3 from '@/parts/dashboard/AddModalV3.vue';
import RenameModal from '@/parts/dashboard/RenameModal.vue';
// import SurveyModal from '@/parts/dashboard/SurveyModal.vue';
import DashboardGrid from '@/parts/dashboard/DashboardGrid.vue';
import DashboardGridItem from '@/parts/dashboard/DashboardGridItem.vue';
import DashboardSpModal from '@/parts/dashboard/DashboardSpModal.vue';
import ClickOutside from 'vue-click-outside';
import UpdateSpModal from '@/parts/dashboard/DashboardUpdateSpModal.vue';

import util, {} from '@/components/util';
import {apiGetDashboard, apiSetDashboard} from '@/api/views/dashboard';
import * as models from '@/class/models/views/dashboard';
import * as graphModels from '@/class/models/views/graph';
import ListDetailV3 from '@/components/util/ListDetailV3.vue';
import ModalDeleteConfirm from '@/components/util/ModalDeleteConfirm.vue';
import NOC from '@/class/common/const';
import API from '@/api/common';

interface IIndividualGadget<GADGET_DATA_TYPE> {
  [sliderINumber: string]: models.IGadget<GADGET_DATA_TYPE>; // key: `${slider}_${i}`
}

export default Vue.extend({
  name: 'Dashboard',
  components: {
    /*GridLayout, GridItem,*/ DashboardGrid, DashboardGridItem,
    ...util, ListDetailV3, GraphTooltip, GadgetEditer3,
    AddNewGadgetV3, RenameModal, ModalDeleteConfirm,
    // SurveyModal,
    DashboardSpModal, UpdateSpModal,
  },
  directives: {
    ClickOutside,
  },
  props: {
    confirmDialog: Function,
    gadgetValue: Object,
    // openGadget: Function,
    // gadgetEditerModal: Boolean,
    // AddGadgetModal: Boolean,
    appData: Object,
  },
  watch: {
    // ★App.vueのdataのgadgetEditerModalが変更されるとDashboard.vueのgadgetEditerModalプロパティも変更されるが、それを検知するために用意
    /*
    gadgetEditerModal: {
      immediate: true,
      handler(newValue) {
        this.mygadgetEditerModal = newValue;
        if (!newValue) {
          this.isEditerBackToAddModal = false;
          this.isNewEditer = false;
        }
      },
    },*/
    // NewGadget(newValue) {
    //   this.myAddGadgetModal = newValue;
    // },
    gadgetValue(newValue) {
      this.selectedGadget = newValue;
    },
    searchSideList(searchText) {
      // 検索語を含む部署をカンマ区切りで出力
      const resultDeps: Set<number> = new Set();
      // 部署名から検索
      for (const dep of this.departments) {
        if (dep.name.indexOf(searchText) > -1) {
          resultDeps.add(dep.departmentID);
          // 親部署も該当に入れる
          if (dep.parentID) {
            resultDeps.add(dep.parentID);
          }
        }
      }
      // ユーザー名から検索
      for (const user of this.users) {
        if (!resultDeps.has(user.departmentID) &&
          `${user.sei}${user.mei}`.indexOf(searchText) > -1) {
          resultDeps.add(user.departmentID);
          const targetDep = this.departments.find((v) => v.departmentID === user.departmentID);
          if (targetDep) {
            resultDeps.add(targetDep.parentID);
          }
        }
      }
      const resultDepsAry = [];
      for (const depID of resultDeps.values()) {
        resultDepsAry.push(depID);
      }
      this.searchResultDepartments = resultDepsAry.join(',');
    },
    departments: {
      deep: true,
      handler(val, oldVal) {
        localStorage.setItem(`department-${this.appData.mail}`, JSON.stringify(this.departments));
      },
    },
    isDefault: {
      handler(val) {
        // TAB以下の初期表示時グラフが重なるため、リサイズ発火する
        if (!val && window.matchMedia('(max-width: 959.9px)').matches) {
          this.$nextTick(() => {
            (this.$refs.dashboardGrid as any[])[0].resized();
          });
        }
      },
    },
  },
  data() {
    return {
      holidingGadget: {} as models.IAddGadget<any>,
      departments: [] as models.IDepartmentInfo[],
      users: [] as models.IUser[],
      groups: [] as models.IGroup[],
      freeboards: [] as models.IFreeboard[],
      gadgets : [] as Array<models.IGadget<any>>,
      individualGadgets: {} as IIndividualGadget<any>,
      indexs: [{
        boardType: NOC.GADGET.DEFAULT.BOARD_TYPE.FREE, boardID: 0,
        name: 'タブ1', layout: [], id: 0,
      }] as models.IGadgetView[],
      isGridLoading: true,
      navigation: {
        compareNavi: true, // 比較グラフのナビゲーション
      } as models.INavigation,
      // layoutDatas: {},
      initialCt1List: [] as models.IGadgetSelectOptions[],
      // sideModalGadget: false,
      // sideModalDashboard: false,
      mygadgetEditerModal: false,
      AddGadgetModal: false,
      designVersion: 0,
      // surveyModal: false,
      // surveyModalMode: '',
      renameEditer: false,
      renameBoardEditer: false,
      selectedTab: 0,
      selectedBoardType: 0,
      selectedUserID: -1,
      selectedDepartmentID: -1,
      selectedGroupID: -1,
      selectedBoardID: -1,
      slider: 0,
      editingKey: -1,
      editingName: '',
      // errorNameFlag: false,
      // errorEmojiFlag: false,
      // connection: false,
      componentGadgets: Gadgets,
      detailModal: false,
      values: {},
      frameData: new CFrame(),
      selectedGadget: {},
      selectedGadgetIndex: null as models.IGadgetIndex | null,
      closeButtonIs: false,
      closeButtonNum: null,
      clickedButtonNum: -1,
      // isNewDesign: true,
      // isNewEditer: false,
      isEditerBackToAddModal: false,
      tooltip: {} as graphModels.ITooltip,
      isResizing: false,
      searchSideList: '',
      searchResultDepartments: '',
      tabMenuModal: false,
      deleteKey: -1,
      deleteGadgetShowFlag: false,
      trashGadgetKey: -1,
      trashGadgetShowFlag: false,
      deleteTabShowFlag: false,
      deleteBoardShowFlag: false,
      nearSideBarFlag: false,
      hoverSideBarFlag: false,
      sideBarShowFlag: true,
      hoverBoardFlag: false,
      hoveredBoardID: '-1',
      isDefault: true, // SP初期表示時はdefault:true
      spNavFirstClicked: false,
      isShowBottom: true,
      DashboardSpModalShowFlag: false,
      selectorshow: false,
      lastClickedGadget: -1,
      ownerFlag: false,
      updateSpModalShowFlag: false,
      clickItemText: '',
      clickItemJob: '',
    };
  },
  created() {
    window.addEventListener('scroll', this.onScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  },
  async mounted() {
    if (this.appData) {
      this.ownerFlag = Number(this.appData.role) === 1;
    }

    if (this.ownerFlag) {
      this.$router.push(`/setting/users`);
    }

    this.$emit('pushPath', this.$route.path);
    // データ取得
    const res = await apiGetDashboard();
    if (res.result) {
      this.designVersion = res.data.surveyInfo.currentVersion;
      // this.isNewDesign = this.designVersion >= NOC.SURVEY.VERSIONS.THIRD;
      this.initialCt1List = res.data.selectOptions;
      const gadgetViews = res.data.gadgetViews;
      if (gadgetViews) {
        this.departments = this.departments.concat(res.data.departments);
        this.users = res.data.users;
        this.groups = res.data.groups;
        this.freeboards = res.data.freeboards;
        this.selectedBoardType = gadgetViews.boardType;
        switch (this.selectedBoardType) {
          case NOC.GADGET.DEFAULT.BOARD_TYPE.FREE:
            this.selectedBoardID = gadgetViews.boardID;
            this.selectedTab = this.TAB_TYPE.FREE;
            break;
          case NOC.GADGET.DEFAULT.BOARD_TYPE.USER:
            this.selectedUserID = gadgetViews.boardID;
            this.selectedTab = this.TAB_TYPE.DEPARTMENT;
            break;
          case NOC.GADGET.DEFAULT.BOARD_TYPE.DEPARTMENT:
            this.selectedDepartmentID = gadgetViews.boardID;
            this.selectedTab = this.TAB_TYPE.DEPARTMENT;
            break;
          case NOC.GADGET.DEFAULT.BOARD_TYPE.GROUP:
            this.selectedGroupID = gadgetViews.boardID;
            this.selectedTab = this.TAB_TYPE.GROUP;
            break;
        }
        this.indexs = gadgetViews.indexs; // 選択中のタブのガジェットリスト
        // FIXME: 稀に新ダッシュボード追加時にviewingの値がindexsの数を超えることがあるため暫定処置
        const slider = gadgetViews.viewing;
        this.slider = slider < this.indexs.length ? slider : 0;
      }
      this.gadgets = this.initIndexData(res.data.gadgets);
      this.isGridLoading = false;
      // this.navigation = res.data.navigation; // DBでナビゲーション表示履歴を持つ場合はres.dataから受け取る
      const navigation = localStorage.getItem(`navigation-${this.appData.mail}`);
      if (navigation) {
        this.navigation = JSON.parse(navigation);
      }
      // this.connection = true;
      // const nextSurvey = res.data.surveyInfo.nextSurvey;
      // if (new Date(nextSurvey) <= new Date()) {
      //   // 調査日が来たらスターとコメントのアンケート表示
      //   this.surveyModalMode = 'SURVEY';
      //   this.surveyModal = true;
      // }
    }

    const localDeps = localStorage.getItem(`department-${this.appData.mail}`);
    if (localDeps) {
      const parsedeps = JSON.parse(localDeps);
      const isClosedDeps = parsedeps.filter((v: any) => v.isClosed === true);
      const addIsClosedDeps = this.departments;
      for (const dep of addIsClosedDeps) {
        for (const isClosedDep of isClosedDeps) {
          if (dep.departmentID === isClosedDep.departmentID) {
            this.$set(dep, 'isClosed', !dep.isClosed);
          }
        }
      }
      this.departments = addIsClosedDeps;
    }

    window.addEventListener('resize', this.pcHiddenScreen);
  },
  computed: {
    GADGET_LIST_SETTINGS(): object {
      return {
        edit: true,
        add: true,
        tab: true,
      };
    },
    TAB_TYPE() {
      return {
        FREE: 0,
        DEPARTMENT: 1,
        GROUP: 3, // BOARD_TYPEに合わせて3を指定
      };
    },
    DEPARTMENTS_PARENTS(): models.IDepartmentInfo[] {
      return this.departments.filter((v) => !v.parentID);
    },
    SIDE_LIST(): any[] {
      let list: any[] = [];
      if (this.selectedTab === this.TAB_TYPE.FREE) {
        list = this.freeboards;
      } else if (this.selectedTab === this.TAB_TYPE.GROUP) {
        list = this.groups;
      } else if (this.selectedTab === this.TAB_TYPE.DEPARTMENT) {
        list = this.departments;
      }
      return list;
    },
    SIDEBAR_ENABLE_NEST(): boolean {
      // 部署のみネスト
      return this.selectedTab === this.TAB_TYPE.DEPARTMENT;
    },
    SIDEBAR_ENABLE_DELETE_ICON(): boolean {
      // フリーボードのみ削除アイコン表示
      return this.selectedTab === this.TAB_TYPE.FREE;
    },
    SELECTED_ID(): string {
      let selectedID = '-1';
      switch (this.selectedTab) {
        case this.TAB_TYPE.FREE:
          selectedID = String(this.selectedBoardID);
          break;
        case this.TAB_TYPE.DEPARTMENT:
          selectedID = this.selectedDepartmentID > -1
            ? `p${this.selectedDepartmentID}`
            : `c${this.selectedUserID}`;
          break;
        case this.TAB_TYPE.GROUP:
          selectedID = String(this.selectedGroupID);
          break;
      }
      return selectedID;
    },
    // SELECTED_IDで選択した部署、グループ、ユーザーのIDを加工
    KAKOU_SELECTED_ID(): any {
      if (this.SELECTED_ID.indexOf('p') === 0) {// 部署
        const num = this.SELECTED_ID.substring(1, this.SELECTED_ID.length);
        return `d${num}`;
        // return this.users.filter((user: any) => String(user.departmentID) === num).map((user: any) => user.userID).toString();
      } else if (this.SELECTED_ID.indexOf('c') === 0) {// ユーザー
        return this.SELECTED_ID.substring(1, this.SELECTED_ID.length).toString();
      } else if (this.selectedTab === this.TAB_TYPE.GROUP) {// グループ
        return `g${this.SELECTED_ID}`.toString();
      }
    },
    // ダッシュボード内で比較対象プルダウンが未設定である先頭のグラフ
    FIRST_COMPARE_EMPTY_GRAPH(): number {
      let firstGadgetI = -1;
      for (const gadgetIndex of this.indexs[this.slider].layout) {
        const indivisual = this.individualGadgets[`${this.slider}_${gadgetIndex.i}`];
        if (indivisual
          && indivisual.data.materials
          && indivisual.data.materials.some((v: any) => v.id === NOC.MATERIAL.V3.MATERIAL.COMPARE_TYPE_AVERAGE.id)
          && indivisual.data.values.compareSetData === '0'
        ) {
          firstGadgetI = gadgetIndex.i;
          break;
        }
      }
      return firstGadgetI;
    },
  },
  methods: {
    getParentID(v: any) {
      return v.departmentID;
    },
    getParentText(v: any) {
      return v.name;
    },
    getChildID(v: any) {
      return v.userID;
    },
    getChildText(v: any) {
      return `${v.sei}${v.mei}`;
    },
    getItemID(v: any) {
      if (this.selectedTab === this.TAB_TYPE.FREE) {
        return v.freeboardID;
      } else if (this.selectedTab === this.TAB_TYPE.GROUP) {
        return v.groupID;
      }
    },
    getItemText(v: any) {
      return v.name;
    },
    onClickGadget(i: number) {
      this.lastClickedGadget = i;
    },
    onSelectSideList(v: any) {
      if (this.selectedTab === this.TAB_TYPE.FREE) {
        this.onClickFreeboard(v.freeboardID);
      } else if (this.selectedTab === this.TAB_TYPE.GROUP) {
        this.onClickGroup(v.groupID);
      }
    },
    toggleNearFlag(flag: boolean) {
      const delay = flag ? 0 : 100;
      setTimeout(() => {
        this.nearSideBarFlag = flag;
      }, delay);
    },
    toggleHoverFlag(flag: boolean) {
      const delay = flag ? 0 : 100;
      setTimeout(() => {
        this.hoverSideBarFlag = flag;
      }, delay);
    },
    toggleBoardHoverFlag(flag: boolean, boardID: string) {
      this.hoverBoardFlag = flag;
      this.hoveredBoardID = boardID;
    },
    getDepartmentsChildren(parentID: number): models.IDepartmentInfo[] {
      return this.departments.filter((v) => parentID && v.parentID === parentID);
    },
    getUsersInDepartment(departmentID: number): models.IUser[] {
      return this.users.filter((v) => v.departmentID === departmentID);
    },
    // グラフ編集後にガジェット定義反映
    updateGadgets(gadgets: Array<models.IGadget<any>>) {
      // this.$emit('closeGadget');  // ★変更
      this.mygadgetEditerModal = false;
      if (this.isEditerBackToAddModal) {
        // this.$emit('openAdd');
        this.AddGadgetModal = true;
      }
      // this.gadgets = gadgets;
      // 編集ボタンを押したガジェットのみにプルダウンの変更を伝える
      if (this.selectedGadgetIndex) {
        const gadgetIndex = this.selectedGadgetIndex;
        const gadget = gadgets.find((v) => v.gadgetID === gadgetIndex.gadgetID && v.default === gadgetIndex.default);
        if (gadget) {
          gadgetIndex.name = gadget.gadget;
          this.setNowAndUser(gadgetIndex, gadget.data.values);
        }
      }
      this.gadgets = this.initIndexData(gadgets);
      this.selectedGadget = this.gadgetValue;
      this.selectedGadgetIndex = null;
    },
    // ダッシュボードのどこか押下したときの処理
    // onClickDashbord() {
    //   this.sideModalGadget = false;
    //   this.sideModalDashboard = false;
    //   this.myAddGadgetModal = false;
    // },
    onClickAccordion(obj: models.IDepartmentInfo) {
      this.$set(obj, 'isClosed', !obj.isClosed);
    },
    // サイドバーイベント処理
    resetBoardID() {
      this.selectedUserID = -1;
      this.selectedDepartmentID = -1;
      this.selectedGroupID = -1;
      this.selectedBoardID = -1;
    },
    async onClickUser(userID: number) {
      // リストからユーザー選択時
      window.scrollTo(0, 0);
      this.resetBoardID();
      this.selectedUserID = userID;
      this.selectedBoardType = NOC.GADGET.DEFAULT.BOARD_TYPE.USER;
      await this.setSelectDashboardData(1, this.selectedUserID);

      const findUser = this.users.find((v: any) => (v.userID === userID));
      if (findUser) {
        const findJob = NOC.JOB.JOBArray.find((v) => v.value === findUser!.jobID);
        if (findJob) {
          this.clickItemText = findUser.name;
          this.clickItemJob = findJob.text;
        }
      }
    },
    async onClickDepartment(departmentID: number) {
      // リストから部署選択時
      window.scrollTo(0, 0);
      this.resetBoardID();
      this.selectedDepartmentID = departmentID;
      this.selectedBoardType = NOC.GADGET.DEFAULT.BOARD_TYPE.DEPARTMENT;
      await this.setSelectDashboardData(2, this.selectedDepartmentID);

      const findDep = this.departments.find((v: any) => v.departmentID === departmentID);
      if (findDep) {
        this.clickItemText = findDep.name;
        this.clickItemJob = '';
      }
    },
    async onClickGroup(groupID: number) {
      // リストからグループ選択時
      window.scrollTo(0, 0);
      this.resetBoardID();
      this.selectedGroupID = groupID;
      this.selectedBoardType = NOC.GADGET.DEFAULT.BOARD_TYPE.GROUP;
      await this.setSelectDashboardData(3, this.selectedGroupID);

      const findGroup = this.groups.find((v: any) => v.groupID === groupID);
      if (findGroup) {
        this.clickItemText = findGroup.name;
        this.clickItemJob = '';
      }
    },
    async onClickFreeboard(boardID: number) {
      // リストからフリーボード選択時
      window.scrollTo(0, 0);
      this.resetBoardID();
      this.selectedBoardID = boardID;
      this.selectedBoardType = NOC.GADGET.DEFAULT.BOARD_TYPE.FREE;
      // this.changeView(this.slider);
      await this.setSelectDashboardData(0, this.selectedBoardID);

      const findFreeboard = this.freeboards.find((v: any) => v.freeboardID === boardID);
      if (findFreeboard) {
        this.clickItemText = findFreeboard.name;
        this.clickItemJob = '';
      }
    },
    onClickEditBoard(v: any) {
      // ボード名右の編集アイコンクリック時
      switch (this.selectedTab) {
        case this.TAB_TYPE.FREE:
          this.onClickRenameBoard(v.freeboardID, v.name);
          break;
        case this.TAB_TYPE.DEPARTMENT:
          if (v.userID) {
            this.onClickUserEdit(v.userID);
          } else {
            this.onClickDepartmentEdit(v.departmentID);
          }
          break;
        case this.TAB_TYPE.GROUP:
          this.onClickGroupEdit(v.groupID);
          break;
      }
    },
    onClickUserEdit(userID: number) {
      this.$router.push(`/setting/users?user_id=${userID}`, () => {});
    },
    onClickDepartmentEdit(departmentID: number) {
      this.$router.push(`/setting/users?department_id=${departmentID}`, () => {});
    },
    onClickGroupEdit(groupID: number) {
      this.$router.push(`/setting/group?id=${groupID}`, () => {});
    },
    onClickTab(key: number) {
      // ダッシュボードのタブ選択
      window.scrollTo(0, 0);
      this.slider = key;
      this.changeView(key);
    },
    onClickOpenTabMenu(key: number) {
      window.scrollTo(0, 0);
      this.clickedButtonNum = key;
      this.tabMenuModal =
        this.clickedButtonNum < 0 || this.clickedButtonNum === key
        ? !this.tabMenuModal // 同じタブをクリックしたら開閉
        : true; // 違うタブをクリックしたら開く
    },
    async onClickAddBoard() {
      // 最大のボードIDを取得
      const maxID = this.freeboards.reduce(
        (prev: models.IFreeboard, current: models.IFreeboard) => {
          return prev.freeboardID > current.freeboardID ? prev : current;
        }, { freeboardID: -1, name: '' });
      // フリーボード追加
      const api = new API();
      const requestData = {
        freeboardID: maxID.freeboardID + 1,
        name: `フリーボード${maxID.freeboardID + 2}`,
      };
      const res = await api.post<models.IFreeboard, models.VFreeboard>('freeboard/new', requestData);
      if (res.result) {
        this.freeboards = res.data.freeboards;
      }
    },
    closeTabMenuModal() {
      this.tabMenuModal = false;
    },
    // ダッシュボードのタブ削除
    onClickDeleteHorse(deleteKey: number) {
      this.deleteKey = deleteKey;
      this.deleteTabShowFlag = true;
    },
    closeDeleteTabModal() {
      this.deleteKey = -1;
      this.deleteTabShowFlag = false;
    },
    async deleteTab() {
      const deleteKey = this.deleteKey;
      // if (await this.confirmDialog('対象タブを削除します、よろしいでしょうか？')) {
        // console.log(deleteKey);
      if (this.indexs.length === 1) {
        this.$emit('info', 'タブは1以下にできません。');
      } else {
        if (this.slider > 0) {
          if (this.slider === deleteKey) {
            this.slider--;
          } else if (deleteKey < this.slider) {
            this.slider--;
          }
        } else {
          this.slider = 0;
        }
        this.isShowBottomSetFalse(); // 一時的に非表示
        this.indexs.splice(deleteKey, 1); // tab削除
        for (let id = 0; id < this.indexs.length; id++) { // タブidを詰める
          this.indexs[id].id = id;
        }
        this.deleteView(this.deleteKey); // 削除登録
      }
      this.deleteTabShowFlag = false;
    },
    onDropHorse() {
      this.addGadget(this.holidingGadget);
    },
    // フリーボード名編集
    onClickRenameBoard(boardID: number, name: string) {
      this.editingKey = boardID;
      this.editingName = name;
      this.renameBoardEditer = true;
    },
    async saveRenameBoard(editingName: string) {
      this.freeboards[this.editingKey].name = editingName;
      const api = new API();
      const res = await api.put<models.IFreeboard, models.VFreeboard>('freeboard/edit', this.freeboards[this.editingKey]);
      if (res.result) {
        this.freeboards = res.data.freeboards;
        this.renameBoardEditer = false;
        this.editingKey = -1;
        this.editingName = '';
      }
    },
    cancelRenameBoard() {
      this.renameBoardEditer = false;
      this.editingName = '';
    },
    // フリーボード削除
    onClickDeleteBoard(boardID: number) {
      this.deleteKey = boardID;
      this.deleteBoardShowFlag = true;
    },
    async deleteBoard() {
      const api = new API();
      const res = await api.delete<models.VFreeboard>('freeboard/delete', { deleteID: this.deleteKey });
      if (res.result) {
        this.freeboards = res.data.freeboards;
      }
    },
    closeDeleteBoardModal() {
      this.deleteKey = -1;
      this.deleteBoardShowFlag = false;
    },
    generateGadget() {
      // グラフ一覧画面のグラフ新規作成ボタン押下
      this.selectedGadget = new models.CGadget();
      this.mygadgetEditerModal = true;
      this.AddGadgetModal = false;
      this.isEditerBackToAddModal = true;
      // this.isNewEditer = true;
        // if (!newValue) {
        //   this.isEditerBackToAddModal = false;
        //   this.isNewEditer = false;
        // }
    },
    addGadgetWithoutRegist(gadget: models.IAddGadget<any>) {
      this.addGadget(gadget, false);
    },
    addGadget(gadget: models.IAddGadget<any>, registFlag: boolean = true) {
      console.log(registFlag);
      if (this.addGadgetLock()) {
        this.$emit('info', 'タブ内にグラフは13個以上登録できません。');
        return ;
      }
      const targetLayout = this.indexs[this.slider].layout;

      // ガジェットごとに固有の番号を振る（追加時間）
      const now = new Date();
      const year = now.getFullYear();
      const mon = now.getMonth() + 1; // １を足すこと
      const day = now.getDate();
      const hour = now.getHours();
      const min = now.getMinutes();
      const sec = now.getSeconds();
      const msec = now.getMilliseconds();
      const gadgetnumber = Number(`${year}${mon}${day}${hour}${min}${sec}${msec}`);
      // console.log(number);

      // 追加箇所を割り出す
      const matrix = [[0, 0, 0, 0]];
      for (const g of targetLayout) {
        for (let y = 0; y <= g.y; y++) {
          if (g.y + 1 > matrix.length) {
            matrix.push([0, 0, 0, 0]);
          }
        }
        // matrix[g.y][g.x] = 1;
        for (let h = 1; h <= g.h; h++) {
          if (g.y + g.h > matrix.length) {
            matrix.push([0, 0, 0, 0]);
          }
          for (let w = 1; w <= g.w; w++) {
            if ((g.x + w - 1) < 4) {
              matrix[g.y + h - 1][g.x + w - 1] = 1;
            }
          }
        }
      }
      let targetX = 0;
      let targetY = 0;
      let full = true;

      // console.log(matrix.length);
      for (let y = 0; y <= (matrix.length - 1); y++) {
        for (let x = 0; x <= (matrix[y].length - 1); x++) {
          // console.log(y,x)
          // console.log(matrix[y][x])
          if (matrix[y][x] === 0) {
            targetX = x;
            targetY = y;
            full = false;
            break;
          }
        }
      }
      if (full) {
        targetY = matrix.length;
      }
      // console.log('target x:', targetX, ' y:', targetY);
      // console.log(gadget);
      const data = {
        x: targetX,
        y: targetY,
        w: 1,
        h: 1,
        // i: targetLayout.length + 1,
        i: gadgetnumber,
        default: gadget.default,
        name: gadget.gadget,
        gadgetID: gadget.gadgetID,
        resized: true,
        notResize: gadget.notResize,
      } as models.IGadgetIndex;
      // グラフ表示の度にsetValuesを呼び出さないようにしたため、ガジェット追加時はここで設定
      this.setNowAndUser(data, gadget.data.values);
      targetLayout.push(data);
      this.individualGadgets[`${this.slider}_${data.i}`] = JSON.parse(JSON.stringify(gadget));
      // console.log(targetLayout);
      // console.log(this.indexs);
      if (registFlag) {
        this.registView(this.indexs[this.slider]);
      }
    },
    editGaget(gaget: models.IGadget<any>, isEditerBackToAddModal?: boolean, gadgetIndex?: models.IGadgetIndex) {
      // this.$router.push({ name: 'Graph', params: { editGaget: gaget }});
      // todo gadget import
      this.selectedGadget = JSON.parse(JSON.stringify(gaget));
      this.selectedGadgetIndex = gadgetIndex || null;
      this.isEditerBackToAddModal = isEditerBackToAddModal || false;
      // this.isNewEditer = gaget.gadget.indexOf('V3') !== -1;
      // this.$emit('openGadget'); // ★変更
      this.mygadgetEditerModal = true;
      this.updateSpModalShowFlag = false;
    },
    trashGadget(index: number) {
      this.trashGadgetShowFlag = true;
      this.trashGadgetKey = index;
      // console.log(index);
      // this.indexs[this.slider].layout = this.indexs[this.slider].layout.filter((v) => (v.i !== index));
      // this.selectedGadgetIndex = null;
      // this.layout = JSON.parse(JSON.stringify(this.layout));
      // console.log(this.layout );
      // this.registView(this.indexs[this.slider]);
    },
    trashGadgetAfter() {
      // console.log(index);
      this.indexs[this.slider].layout = this.indexs[this.slider].layout.filter((v) => (v.i !== this.trashGadgetKey));
      this.selectedGadgetIndex = null;
      // this.layout = JSON.parse(JSON.stringify(this.layout));
      // console.log(this.layout );
      this.registView(this.indexs[this.slider]);
    },
    closeTrashGadgetModal() {
      this.trashGadgetShowFlag = false;
      this.trashGadgetKey = -1;
      this.$nextTick(() => {
        (this.$refs.dashboardGrid as any[])[0].resized();
      });
    },
    async addCreatedGadget(newGadget: models.IGadget<any>) {
      // グラフ一覧 -> グラフ作成 -> ダッシュボードに追加
      this.isEditerBackToAddModal = false;
      const gadget = newGadget as models.IAddGadget<any>;
      gadget.notResize = false;
      this.addGadget(gadget);
    },
    // グラフ削除
    onClickDeleteGadget(targetID: number) {
      this.deleteKey = targetID;
      this.deleteGadgetShowFlag = true;
    },
    // グラフ選択リセット
    selectGadgetsReset() {
      (this.$refs.addNewGadgetV3 as any).resetSelectGadget();
    },
    closeDeleteGadgetModal() {
      this.deleteGadgetShowFlag = false;
      this.deleteKey = -1;
    },
    async deleteGadget() {
      // ダッシュボードで使用中の場合削除不可
      let deleteFlag = true;
      for (const layoutIndex of this.indexs) {
        const useLayout = layoutIndex.layout.find((v) => (v.gadgetID === this.deleteKey && v.default === false));
        if (useLayout) {
          deleteFlag = false;
          break;
        }
      }
      if (!deleteFlag) {
        this.$emit('info', '使用中のため削除できません。');
        return;
      }
      const api = new API();
      const res = await api.delete<graphModels.VGraph>('graph/delete', {deleteID: this.deleteKey});
      if (res.result) {
        this.selectedGadgetIndex = null;
        this.updateGadgets(res.data.gadgets);
        // ダッシュボード 作成したグラフの削除時に選択済みをリセットする
        this.selectGadgetsReset();
      } else {
        this.$emit('info', '削除できませんでした。');
      }
    },
    addHorse() {
      if (this.indexs.length >= 10) {
        return;
      }
      const tabId = this.indexs[this.indexs.length - 1].id + 1;
      this.indexs.splice( this.indexs.length , 0, {
        boardType: this.selectedBoardType,
        boardID: this.getCurrentBoardID(this.selectedBoardType),
        // name: `新しいタブ`, layout: [], id: this.indexs.length + 1,
        name: `新しいタブ`, layout: [], id: tabId,
      });
      this.registView(this.indexs[this.indexs.length - 1]);
    },
    renameHorse(key: number) {
      this.renameEditer = true;
      this.editingKey = key;
      this.editingName = this.indexs[key].name;
    },
    // onInput(value: string) {
    //   if (value.length <= 15) {
    //     this.errorNameFlag = false;
    //   } else {
    //     this.errorNameFlag = true;
    //   }
    //   if (!commonValidation.hasEmoji(value, 'emoji')) {
    //     this.errorEmojiFlag = false;
    //   } else {
    //     this.errorEmojiFlag = true;
    //   }
    //   this.editingName = value;
    // },
    // onChange(value: any) {
    //   validation.checkValue(value, this.editingName);
    // },
    saveRenameHorse(editingName: string) {
      // if (!this.errorNameFlag && !this.errorEmojiFlag) {
        this.renameEditer = false;
        this.indexs[this.editingKey].name = editingName;
        this.editingName = '';
        this.registView(this.indexs[this.editingKey]);
        this.editingKey = -1;
      // }
    },
    cancelRenameHorse() {
      this.renameEditer = false;
      // this.errorNameFlag = false;
      // this.errorEmojiFlag = false;
      this.editingName = '';
    },
    onMoved(moveItem: any) {
      const fromIndex = moveItem.fromIndex;
      const toIndex = moveItem.toIndex;
      const copiedLayout = JSON.parse(JSON.stringify(this.indexs[this.slider])); // ディープコピー
      this.indexs[this.slider].layout.splice(fromIndex, 1); // ドラッグされたitemを削除
      this.indexs[this.slider].layout.splice(toIndex, 0, copiedLayout.layout[fromIndex]); // 削除したアイテムをドラッグ先に追加
      this.registView(this.indexs[this.slider]);
    },
    onResize(gadget: models.IGadgetIndex) {
      this.isResizing = true;
      gadget.resized = false;
    },
    onResized(gadget: models.IGadgetIndex) {
      gadget.resized = true;
      this.isResizing = false;
      this.registView(this.indexs[this.slider]);
    },
    // サイドバー選択項目のダッシュボードを取得
    async setSelectDashboardData(boardType: number, boardID: number) {
      const api = new API();
      const res = await api.get<models.VDashboard>('dashboard/board', { boardType, boardID });
      this.isGridLoading = true;
      this.indexs = res.data.gadgetViews.indexs;
      this.slider = res.data.gadgetViews.viewing;
      this.individualGadgets = {};
      this.gadgets = this.initIndexData(res.data.gadgets);
      this.isGridLoading = false;
      // navigationは初期表示時だけ更新する
      this.registView(this.indexs[this.slider]);
    },
    async registView(data: models.IGadgetView) {
      // resizedがfalseで渡されることがあるのでtrueにする。(グラフが表示されないことに対する対応)
      for (const d of data.layout) {
        d.resized = true;
      }
      const api = new API();
      const res = await api.post<models.IGadgetView, any>('dashboard/set', data);
    },
    async changeView(key: number) {
      const api = new API();
      const res = await api.post<models.IGadgetViewIDs, any>('dashboard/viewing', {
        boardType: this.selectedBoardType,
        boardID: this.getCurrentBoardID(this.selectedBoardType),
        id: key,
      });
    },
    async deleteView(deleteKey: number) {
      const api = new API();
      const res = await api.post<models.IGadgetViews, any>('dashboard/delete', {
        boardType: this.selectedBoardType,
        boardID: this.getCurrentBoardID(this.selectedBoardType),
        viewing: this.slider, indexs: this.indexs,
      });

      if (res.result === 'success') {
        // individualGadgets値再設定
        let nextIndividualGadgets: IIndividualGadget<any> = {};
        for (const id of Object.keys(this.individualGadgets)) {
          const key = id.split('_');
          if (deleteKey === Number(key[0])) {
            // 削除
            continue;
          } else if (deleteKey > Number(key[0])) {
            // そのまま
            nextIndividualGadgets[`${key[0]}_${key[1]}`] = this.individualGadgets[id];
            continue;
          } else if (deleteKey < Number(key[0])) {
            // 値を修正
            nextIndividualGadgets[`${Number(key[0]) - 1}_${key[1]}`] = this.individualGadgets[id];
          }
        }
        this.individualGadgets = {}; // 初期化
        this.individualGadgets = { ...nextIndividualGadgets }; // タブ削除後の値を設定
        nextIndividualGadgets = {};
        this.$nextTick(() => {
          this.refreshBottom(); // ガジェット再表示
        });
      }
    },
    getGadgetName(gadgetName: string) {
      // 第二次デザインで作られたグラフは新旧デザインを切り替える
      // 第三次デザインで作られたグラフはそのまま表示
      // return !this.isNewDesign
      //   ? gadgetName
      //   : gadgetName.indexOf('V3') === -1
      //     ? gadgetName + 'V3'
      //     : gadgetName;
      // REMOLABO-413 新デザインに完全移行
      return gadgetName.indexOf('V3') === -1 ? gadgetName + 'V3' : gadgetName;
    },
    // GetGadgetData(gadget: models.IGadgetIndex): models.IGadget<any> {
    //   const targetGadget = this.gadgets.find((v) => (v.gadgetID === gadget.gadgetID && v.default === gadget.default));
    //   return targetGadget || new models.CGadget();
    // },
    showDetail(values: models.IValues) {
      this.values = values;
      this.detailModal = true;
    },
    addGadgetLock(addNum?: number): boolean {
      return 12 <= this.indexs[this.slider].layout.length + (addNum || 0);
    },
    async setValues(inData: any[], iNumber: number) {
      const gadgetData: models.IGadget<any> = inData[0];
      const gadgetValue: models.IValues = inData[1];
      this.indexs[this.slider].layout.filter((i) => {
        if (i.gadgetID === gadgetData.gadgetID && i.default === gadgetData.default && i.i === iNumber) {
          this.setNowAndUser(i, gadgetValue);

          const individual = this.individualGadgets[`${this.slider}_${i.i}`];
          individual.data.values.date = i.now || '';
          individual.data.values.dateto = i.nowto || '';
          individual.data.values.setData = i.user || '0';
          individual.data.values.compareSetData = i.cuser || '0';

          if (i.cuser && String(i.cuser) !== '0') {
            // 比較対象が設定された場合、ナビゲーションをOFFにする
            this.closeNavigation('compareNavi');
          }
        }
      });
      this.registView(this.indexs[this.slider]);
    },
    setTooltip(data: graphModels.ITooltip) {
      this.tooltip = JSON.parse(JSON.stringify(data));
    },
    onScroll() {
      // スクロールしたらグラフツールチップを非表示にする
      if (this.tooltip.tooltipModel) {
        this.tooltip.tooltipModel.opacity = 0;
      }
    },
    // グラフのナビゲーション
    getNavigation(i: number): models.INavigation {
      return {
        // ダッシュボードの最初の比較グラフにナビゲーション表示
        compareNavi: this.navigation.compareNavi && i === this.FIRST_COMPARE_EMPTY_GRAPH,
      };
    },
    closeNavigation(prop: string) {
      if (prop === 'compareNavi') { // 増えたら prop === 'xxx' || prop === 'yyy' のようにする
        this.navigation[prop] = false;
      }
      localStorage.setItem(`navigation-${this.appData.mail}`, JSON.stringify(this.navigation));
    },
    initIndexData(data: Array<models.IGadget<any>>) {
      if (!data) {
        return [];
      }
      for (const d of data) {
        // グラフ追加画面で表示されるプルダウン値
        const index = this.indexs[this.slider].layout.find((v) => (v.default === d.default && v.gadgetID === d.gadgetID));
        if (index) {
          let selectedID: any = '';
          selectedID = this.KAKOU_SELECTED_ID;

          d.data.values.date = index.now || '';
          d.data.values.dateto = index.nowto || '';
          d.data.values.setData = index.user || selectedID || '0'; // ★グラフ追加画面でもサイドバーで選択したユーザーのグラフを表示する場合はこちらも下と同様に変更
          d.data.values.compareSetData = index.cuser || '0';
        }
        for (const slider of Object.keys(this.indexs)) {
          for (const idx of this.indexs[Number(slider)].layout) {
            if (idx.default === d.default && idx.gadgetID === d.gadgetID) {
              const copiedGadget: models.IGadget<any> = JSON.parse(JSON.stringify(d));
              let selectedID: any = '';
              selectedID = this.KAKOU_SELECTED_ID;
              // 全メンバーグラフの場合、初期表示は全メンバーを選択
              if (copiedGadget.data.materials) {
                const getTargetSetData = NOC.MATERIAL.V3.getTargetSetData(copiedGadget.data.materials);
                if (getTargetSetData === undefined && !idx.user) {
                  selectedID = this.users.map((user: any) => user.userID).toString();
                } else if (getTargetSetData && getTargetSetData.id === NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_DEPARTMENT_MULTI.id) {
                  // 複数部署の場合は先頭のdを削除
                  selectedID = String(selectedID).replace('d', '');
                }
              }
              copiedGadget.data.values.date = idx.now || d.data.values.date;
              copiedGadget.data.values.dateto = idx.nowto || d.data.values.dateto;
              copiedGadget.data.values.setData = idx.user || selectedID || d.data.values.setData; // ★idx.user（DB保存値）が無ければサイドバー選択ユーザーをプルダウンに設定
              copiedGadget.data.values.compareSetData = idx.cuser || d.data.values.compareSetData;
              this.individualGadgets[`${slider}_${idx.i}`] = copiedGadget;
              // console.log('copiedGadget',copiedGadget)
            }
          }
        }
      }
      return data;
    },
    setNowAndUser(target: models.IGadgetIndex, origin: models.IValues) {
      target.now = origin.date;
      if (origin.dateto) {
        target.nowto = origin.dateto;
      }
      target.user = origin.setData;
      if (origin.compareSetData) {
        target.cuser = origin.compareSetData;
      }
    },
    closeButtonOn(key: any) {
      this.closeButtonIs = true;
      this.closeButtonNum = key;
    },
    closeButtonOff(key: any) {
      this.closeButtonIs = false;
    },
    closeGadget() {
      // グラフ作成画面,グラフ編集画面の戻るボタン押下
      this.selectedGadgetIndex = null;
      // this.$emit('closeGadget');
      this.mygadgetEditerModal = false;
      this.selectedGadget = {};
      if (this.isEditerBackToAddModal) {
        // this.$emit('openAdd');
        this.AddGadgetModal = true;
      }
    },
    closeAddGadget() {
      // this.$emit('closeAdd');
      this.AddGadgetModal = false;
    },
    // グラフ追加対応リリース時の「新しいデザインを試す」用処理
    /*
    onClickNewDesign() {
      if (this.designVersion === NOC.SURVEY.VERSIONS.UNDEFINED) {
        // 初回のみ「ようこそ」表示
        this.surveyModalMode = 'NEW_DESIGN';
        this.surveyModal = true;
      } else {
        this.changeDesign(true);
      }
    },
    async changeDesign(isNew: boolean) {
      this.isNewDesign = isNew;
      this.surveyModal = false;

      // 現在のデザインをDBに保存
      const api = new API();
      const res = await api.post<models.VSurveyChangeVersion, models.ISurvey>('survey/changedesign',
        { currentVersion: this.isNewDesign ? NOC.SURVEY.VERSIONS.THIRD : NOC.SURVEY.VERSIONS.SECOND });
    },
    */
    getCurrentBoardID(boardType: number) {
      let id = -1;
      switch (boardType) {
        case NOC.GADGET.DEFAULT.BOARD_TYPE.FREE:
          id = this.selectedBoardID;
          break;
        case NOC.GADGET.DEFAULT.BOARD_TYPE.USER:
          id = this.selectedUserID;
          break;
        case NOC.GADGET.DEFAULT.BOARD_TYPE.DEPARTMENT:
          id = this.selectedDepartmentID;
          break;
        case NOC.GADGET.DEFAULT.BOARD_TYPE.GROUP:
          id = this.selectedGroupID;
          break;
      }
      return id;
    },
    refreshDashboard() {
      // this.$nextTickでは実行タイミングが速い transition対策
      setTimeout(() => {
        (this.$refs.dashboardGrid as any[])[0].resized();
      }, 300);
    },
    refreshBottom() {
      this.isShowBottom = false;
      this.$nextTick(() => {
        this.isShowBottom = true;
      });
    },
    isShowBottomSetFalse() {
      this.isShowBottom = false;
    },
    onClickClose() {
      this.$emit('close');
    },
    onShowModalSp() {
      this.DashboardSpModalShowFlag = true;
    },
    onClickSpCloseModal() {
      this.DashboardSpModalShowFlag = false;
    },
    onClickLogo() {
      if (this.mygadgetEditerModal) {
        this.mygadgetEditerModal = false;
      }
      if (this.AddGadgetModal) {
        this.AddGadgetModal = false;
      }
      if (this.updateSpModalShowFlag) {
        this.updateSpModalShowFlag = false;
      }
    },
    pcHiddenScreen() {
      if (window.innerWidth >= 960) {
        if (this.DashboardSpModalShowFlag) {
          this.onClickSpCloseModal();
        }
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.pcHiddenScreen);
  },
});
